import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  UpdateCauseMutation,
  UpdateCauseMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateCauseDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateCauseTRPCInput = {
  Id: string;
  ParentIssueId: string;
  Title: string;
  Description?: string | null;
  Significance?: number | null;
  CustomAttributeData?: CustomAttributeData | null;
  OriginalTimestamp: string;
};

export const useUpdateCause = createMutationHook({
  name: 'updateCause',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.cause.update.mutationOptions({ onSuccess }),
  mapInput: (
    variables: UpdateCauseMutationVariables
  ): UpdateCauseTRPCInput => ({
    Id: variables.Id ?? '',
    ParentIssueId: variables.ParentIssueId ?? '',
    Title: variables.Title ?? '',
    Description: variables.Description,
    Significance: variables.Significance,
    CustomAttributeData: variables.CustomAttributeData ?? null,
    OriginalTimestamp: variables.OriginalTimestamp ?? '',
  }),
  invalidate: (trpc) => [
    trpc.frontend.cause.register.queryKey(),
    trpc.frontend.cause.getById.queryKey(),
    trpc.frontend.cause.getByParentIssueId.queryKey(),
  ],
  mapResponse: (): UpdateCauseMutation => ({
    update_cause: {
      __typename: 'cause_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateCauseDocument,
  graphqlVariables: (variables: UpdateCauseMutationVariables) => ({
    ...variables,
  }),
  validateGraphqlResponse: (data) => {
    if (data.update_cause?.affected_rows !== 1) {
      throw new Error(
        'Records not updated. Record may have been updated by another user'
      );
    }
  },
  evictFields: ['cause', 'cause_aggregate'],
});
